<div class="relative">
  @if (showCloseButton) {
    <button
      (click)="closeComponent.emit()"
      type="button"
      class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-4 mt-4 inline-flex justify-center items-center cursor-pointer absolute -top-2.5 -start-15"
      appAgentAction
      agent="upload-file-close"
      action="close"
    >
      <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
        />
      </svg>
      <span class="sr-only">Close sidebar</span>
    </button>
  }
  @if (!labelIsHidden) {
    <label class="block ms-2 text-sm font-medium text-gray-500" for="small_size">{{ label }}</label>
  }
  <input
    class="block w-full text-xs text-gray-500 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 focus:outline-none file:bg-amazone-orange file:text-white"
    id="small_size"
    type="file"
    (change)="onFileSelected($event)"
    [accept]="accept"
    [multiple]="multiple"
    appAgentAction
    agent="upload-file-upload"
    action="upload"
  />
</div>
